import * as API from "../../Utils/Services/api";
import { useEffect, useState, useRef } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { ethers, Contract } from "ethers";
import translation from "../Translations/translation.json";
import PlaceholderLoading from "react-placeholder-loading";
import { toast } from "react-toastify";
import { swapContract } from "../../Ethereum/Constant/addresses";
import { swapABI, poolABI, ERC20ABI } from "../../Ethereum/Constant/abis";
import { contractInstance, signer } from "../../Ethereum/Connect/config";
import ethImg from "../../Assets/tinified/token-5.png";
import "./Banner.css";
import "../../App.css";
import { BrowserProvider } from "ethers";
import Loading from "../Loading/Loading";
import { useLanguage } from "../LanguageContext";
import getTokenBalance from "../../Utils/getTokenBalance";
import V3Swap from "./V3Swap";

const logos = [
  {
    name: "POL",
    link: "/",
  },
  {
    name: "SHIB",
    link: "/",
  },
  {
    name: "USDP",
    link: "/",
  },
  {
    name: "SHIELDS",
    link: "/",
  },
  {
    name: "CRV",
    link: "/",
  },
  {
    name: "TUBBY",
    link: "/",
  },
  {
    name: "WBTC",
    link: "/",
  },
  {
    name: "ETH",
    link: "/",
  },
  {
    name: "USDC",
    link: "/",
  },
  {
    name: "MANA",
    link: "/",
  },
];
const Banner = () => {
  const [value, setValue] = useState("");
  const containerRef = useRef(null);
  const [showModal, setShowModal] = useState(false);
  const [estimateTokenValue, setEstimateTokenValue] = useState("");
  const [estimateETHWValue, setEstimateETHWValue] = useState("");
  const [tokenData, setTokenData] = useState(null);
  const [isSwapped, setIsSwapped] = useState(false);
  const [selectedToken, setSelectedToken] = useState(null);
  const [loading, setLoading] = useState(false);
  const debounceTimeout = useRef(null);
  const [allTokensLoading, setAllTokensLoading] = useState(false);
  const [totalAllTokens, setTotalAllTokens] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(30);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedVersion, setSelectedVersion] = useState("v3");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // new
  const [ethwBalance, setEthwBalance] = useState(null);
  const [balance, setBalance] = useState("");
  const [error, setError] = useState("");

  const handleVersionChange = (version) => {
    setIsDropdownOpen(false);
    setSelectedVersion(version);
    localStorage.setItem("swapVer", version);

    const qs = new URLSearchParams(location.search);
    qs.set("ver", version);
    navigate({ search: qs.toString() }, { replace: true });
  };

  useEffect(() => {
    if (selectedVersion === "v2") setIsDropdownOpen(false);
  }, [selectedVersion]);
  const fetchETHWBalance = async () => {
    try {
      if (!window.ethereum) {
        // setError("MetaMask is not installed!");
        setEthwBalance(null);
        return;
      }

      const accounts = await window.ethereum.request({
        method: "eth_accounts",
      });
      if (!accounts.length) {
        setEthwBalance(null);
        return;
      }

      const provider = new BrowserProvider(window.ethereum);
      const signer = await provider.getSigner();

      const balance = await provider.getBalance(signer.address);
      const formattedBalance = parseFloat(ethers.formatEther(balance)).toFixed(
        6
      );
      setEthwBalance(formattedBalance);
      setError("");
    } catch (err) {
      console.error("Error fetching ETHW balance:", err.message);
      // setError("Failed to fetch balance. Please try again.");
      setError(translate("fetchBalanceFailed"));
      setEthwBalance(null);
    }
  };

  const fetchTokenBalance = async () => {
    if (!window.ethereum || !selectedToken?.address) {
      setBalance("");
      return;
    }

    try {
      const accounts = await window.ethereum.request({
        method: "eth_accounts",
      });
      if (!accounts.length) {
        setBalance("");
        return;
      }

      const provider = new BrowserProvider(window.ethereum);
      const signer = await provider.getSigner();

      // Create token contract instance
      const tokenContract = new ethers.Contract(
        selectedToken.address,
        [
          "function balanceOf(address account) view returns (uint256)",
          "function decimals() view returns (uint8)",
        ],
        provider
      );

      const rawBalance = await tokenContract.balanceOf(signer.address);
      const decimals = await tokenContract.decimals();
      setBalance(
        parseFloat(ethers.formatUnits(rawBalance, decimals)).toFixed(6)
      );
    } catch (err) {
      console.error(err);
      // setBalance("Error fetching balance");
      setBalance(translate("errorFetchingBalance"));
    }
  };
  useEffect(() => {
    const connectedWallet = sessionStorage.getItem("account");
    if (!connectedWallet) {
      setEthwBalance(null);
      setBalance("");
    } else {
      // fetchETHWBalance();
      fetchTokenBalance();
    }
  }, [selectedToken]);
  useEffect(() => {
    if (!window.ethereum) return;

    const handleAccountsChanged = (accounts) => {
      const connectedWallet = sessionStorage.getItem("account");

      if (!connectedWallet) {
        setEthwBalance(null);
        setBalance("");
        return;
      }

      // MetaMask has no active accounts
      if (!accounts || accounts.length === 0) {
        setEthwBalance(null);
        setBalance("");
        return;
      }

      // fetchETHWBalance();
      fetchTokenBalance();
    };

    const handleChainChanged = () => {
      const connectedWallet = sessionStorage.getItem("account");
      if (!connectedWallet) {
        setEthwBalance(null);
        setBalance("");
        return;
      }
      // fetchETHWBalance();
      fetchTokenBalance();
    };

    window.ethereum.on("accountsChanged", handleAccountsChanged);
    window.ethereum.on("chainChanged", handleChainChanged);

    return () => {
      window.ethereum.removeListener("accountsChanged", handleAccountsChanged);
      window.ethereum.removeListener("chainChanged", handleChainChanged);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedToken]);

  // new close

  /// Estimate ETHW value from token input value
  const handleTokenInput = (e) => {
    // setValue(e.target.value.replace(/[^0-9]/g, ""));

    const value = parseFloat(e.target.value.trim()) || 0;
    setEstimateTokenValue(e.target.value);

    // if (/^0+(\.0+)?$/.test(value)) {
    //   setEstimateETHWValue("");
    //   setEstimateTokenValue("");
    //   return;
    // }
    if (!selectedToken) return;

    // Clear previous timeout
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    // Set new debounce timeout
    debounceTimeout.current = setTimeout(async () => {
      if (e.target.value === "") return;
      try {
        const contract = await contractInstance(swapContract, swapABI);
        const poolAddress = await contract.getPair(selectedToken.address);

        if (poolAddress === "0x0000000000000000000000000000000000000000")
          // return toast.info("Liquidity pool not exist!");
          return toast.info(`${translate("liquidityNotExist")}`);

        const poolContract = await contractInstance(poolAddress, poolABI);
        // const expectedTokenOut = await poolContract.getSwapOutput(
        //   false,
        //   ethers.parseEther(String(value))
        // );
        const expectedTokenOut = await poolContract.getEthInForTokenOut(
          ethers.parseEther(String(value))
        );
        setEstimateETHWValue(ethers.formatEther(String(expectedTokenOut)));
      } catch (err) {
        if (err.reason === "Panic due to DIVIDE_BY_ZERO(18)")
          // return toast.error("Liquidity pool not exist!");
          return toast.error(`${translate("liquidityNotExist")}`);
        toast.error(err.reason);
        // console.log("192", err.info.error.message);
      }
    }, 1000);
  };

  const handleTokenSwapInput = (e) => {
    const value = e.target.value.trim() || 0;
    setEstimateTokenValue(e.target.value);

    // if (/^0+(\.0+)?$/.test(value)) {
    //   setEstimateETHWValue("");
    //   setEstimateTokenValue("");
    //   return;
    // }
    if (!selectedToken) return;

    // Clear previous timeout
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    // Set new debounce timeout
    debounceTimeout.current = setTimeout(async () => {
      if (e.target.value === "") return;
      try {
        const contract = await contractInstance(swapContract, swapABI);
        const poolAddress = await contract.getPair(selectedToken.address);
        if (poolAddress === "0x0000000000000000000000000000000000000000")
          // return toast.info("Liquidity pool not exist!");
          return toast.info(`${translate("liquidityNotExist")}`);
        const poolContract = await contractInstance(poolAddress, poolABI);
        // const expectedTokenOut = await poolContract.getEthInForTokenOut(
        //   ethers.parseEther(String(value))
        // );
        const expectedTokenOut = await poolContract.getSwapOutput(
          false,
          ethers.parseEther(String(value))
        );
        setEstimateETHWValue(ethers.formatEther(String(expectedTokenOut)));
      } catch (err) {
        if (err.reason === "Panic due to DIVIDE_BY_ZERO(18)")
          // return toast.error("Liquidity pool not exist!");
          return toast.error(`${translate("liquidityNotExist")}`);
        toast.error(err.reason);
        // console.log("192", err.info.error.message);
      }
    }, 1000);
  };

  /// Estimate Token value from ETHW input value
  const handleETHWInput = (e) => {
    // setValue(e.target.value.replace(/[^0-9]/g, ""));
    let value = e.target.value === "" ? 0 : parseFloat(e.target.value);
    setEstimateETHWValue(e.target.value);

    // if (/^0+(\.0+)?$/.test(value)) {
    //   setEstimateETHWValue("");
    //   setEstimateTokenValue("");
    //   return;
    // }
    if (!selectedToken) return;

    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(async () => {
      if (e.target.value === "") return;

      try {
        const contract = await contractInstance(swapContract, swapABI);
        const poolAddress = await contract.getPair(selectedToken.address);

        if (poolAddress === "0x0000000000000000000000000000000000000000")
          // return toast.info("Liquidity pool not exist!");
          return toast.info(`${translate("liquidityNotExist")}`);

        const poolContract = await contractInstance(poolAddress, poolABI);
        const expectedTokenOut = await poolContract.getSwapOutput(
          true,
          ethers.parseEther(String(value))
        );
        setEstimateTokenValue(ethers.formatEther(String(expectedTokenOut)));
      } catch (err) {
        if (err.reason === "Panic due to DIVIDE_BY_ZERO(18)")
          // return toast.error("Liquidity pool not exist!");
          return toast.error(`${translate("liquidityNotExist")}`);
        toast.error(err.reason);
      }
    }, 1000);
  };

  const handleETHWSwapInput = (e) => {
    const value = parseFloat(e.target.value.trim()) || 0;
    setEstimateETHWValue(e.target.value);

    // if (/^0+(\.0+)?$/.test(value)) {
    //   setEstimateTokenValue("");
    //   setEstimateETHWValue("");
    //   return;
    // }
    if (!selectedToken) return;

    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(async () => {
      if (e.target.value === "") return;
      try {
        const contract = await contractInstance(swapContract, swapABI);
        const poolAddress = await contract.getPair(selectedToken.address);
        if (poolAddress === "0x0000000000000000000000000000000000000000")
          // return toast.info("Liquidity pool not exist!");
          return toast.info(`${translate("liquidityNotExist")}`);

        const poolContract = await contractInstance(poolAddress, poolABI);
        const expectedTokenOut = await poolContract.getTokenInForEthOut(
          ethers.parseEther(String(value))
        );
        // const expectedTokenOut = await poolContract.getSwapOutput(
        //   false,
        //   ethers.parseEther(String(value))
        // );
        setEstimateTokenValue(ethers.formatEther(String(expectedTokenOut)));
      } catch (err) {
        if (err.reason === "Panic due to DIVIDE_BY_ZERO(18)")
          // return toast.error("Liquidity pool not exist!");
          return toast.error(`${translate("liquidityNotExist")}`);
        if (err.reason === "ethOut invalid")
          // return toast.error("Out of ETHW reserved");
          return toast.error(`${translate("outOfEthwReserve")}`);
        toast.error(err.reason);
      }
    }, 1000);
  };

  const swapDivs = () => {
    setIsSwapped(!isSwapped);
  };
  // useEffect(() => {
  //   (async () => {
  //     const data = {
  //       page: 1,
  //       size: 0,
  //       category,
  //       sortBy,
  //       sortDirection,
  //     };
  //     const resp = await API.GetRWACurrencies(data);
  //     setTokenData(resp.data.currency);
  //   })();
  // }, []);

  const getAllTokenDetail = async (
    page = 1,
    size = rowsPerPage,
    filter = ""
  ) => {
    try {
      setAllTokensLoading(true);
      const data = {
        page,
        size,
        filter,
      };
      const resp = await API.GetAllToken(data);
      // setTokenData(resp.data.tokens);
      const tokens = resp.data.tokens || [];
      setTokenData((prev) => (page === 1 ? tokens : [...prev, ...tokens]));
      setTotalAllTokens(resp.data.total);
      setTotalPages(Math.ceil(resp.data.total / size));
      setAllTokensLoading(false);
    } catch (err) {
      // toast.error(err.response.data.message);
      toast.info("No token found");
      setTokenData([]);
      setAllTokensLoading(false);
      setTotalAllTokens(0);
      setTotalPages(1);
    }
  };
  // useEffect(() => {
  //   getAllTokenDetail();
  // }, []);

  // Fetch token data from contract
  // const selectHandler = async (e) => {
  //   try {
  //     const tokenContract = await contractInstance(e.target.value, ERC20ABI);
  //     const name = await tokenContract.name();
  //     const symbol = await tokenContract.symbol();

  //     if (name && symbol) {
  //       setTokenData([
  //         { image: "", name, symbol, contractAddress: e.target.value },
  //       ]);
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  // Fetch token data from powtoken database
  const selectHandler = (e) => {
    const filter = e.target.value;
    // Clear previous timeout
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    debounceTimeout.current = setTimeout(() => {
      setCurrentPage(1);
      setTokenData([]);
      // getAllTokenDetail(1, rowsPerPage, filter);
    }, 500);
  };

  const selectTokenHandler = (data) => {
    setSelectedToken(data);
  };
  const handleScroll = () => {
    const container = containerRef.current;
    if (!container || allTokensLoading) return;

    if (
      container.scrollTop + container.clientHeight >=
      container.scrollHeight - 50
    ) {
      if (currentPage < totalPages) {
        const nextPage = currentPage + 1;
        setCurrentPage(nextPage);
        // getAllTokenDetail(nextPage, rowsPerPage, selectedToken || "");
      }
    }
  };
  // const swapHandler = async () => {
  //   if (!sessionStorage.getItem("account")) {
  //     // toast.error("Please connect metamask wallet");
  //     toast.info(`${translate("pleaseConnectMetamask")}`);
  //     return;
  //   }
  //   try {
  //     setLoading(true);
  //     const contract = await contractInstance(swapContract, swapABI);
  //     const poolAddress = await contract.getPair(selectedToken.address);
  //     const poolContract = await contractInstance(poolAddress, poolABI);

  //     if (isSwapped) {
  //       const userSigner = await signer();
  //       let provider = new BrowserProvider(window.ethereum);
  //       const tokenContract = await contractInstance(
  //         selectedToken.address,
  //         ERC20ABI
  //       );
  //       const tokenBalance = await tokenContract.balanceOf(userSigner);
  //       if (
  //         parseFloat(ethers.formatEther(String(tokenBalance))) <=
  //         parseFloat(estimateTokenValue)
  //       ) {
  //         setLoading(false);
  //         setEstimateETHWValue("");
  //         setEstimateTokenValue("");
  //         // return toast.info("Insufficient balance");
  //         return toast.info(`${translate("insufficientBalance")}`);
  //       }
  //       const approveTx = await tokenContract.approve(
  //         poolAddress,
  //         ethers.parseEther(estimateTokenValue)
  //       );
  //       // toast.info("Approve transaction sent! Waiting for confirmation...");
  //       toast.info(`${translate("approveTxPending")}`);
  //       await approveTx.wait();
  //       // toast.success("Approval successfull!");
  //       toast.success(`${translate("approvalSuccess")}`);
  //       // toast.info("Please confirm again for the transaction in metamask!");
  //       toast.info(`${translate("approvalSuccess")}`);
  //       const tx = await poolContract.swapTokens(
  //         false,
  //         ethers.parseEther(estimateTokenValue)
  //       );

  //       // toast.info("Swapping transaction initialized");
  //       toast.info(`${translate("swapInit")}`);
  //       await tx.wait();

  //       // const data = {
  //       //   from: userSigner.address,
  //       //   to: poolAddress,
  //       //   amountOfEthW: estimateETHWValue,
  //       //   amountOfToken: estimateTokenValue,
  //       //   transactionHash: tx.hash,
  //       //   poolAddress: poolAddress,
  //       //   tokenAddress: selectedToken.contractAddress,
  //       //   userAddress: userSigner.address,
  //       //   tradeType: false,
  //       //   tokenName: selectedToken.name,
  //       // };

  //       // const resp = await API.SwapToken(data);
  //       // if (!resp.data.status) return toast.info(resp.data.message);
  //       // console.log("357", resp.data.message);

  //       // const userAddress = await signer().getAddress();
  //       const blockNumber = await provider.getBlockNumber();
  //       const ethwReserve = await poolContract.ethwReserve();
  //       const tokenReserve = await poolContract.tokenReserve();
  //       const getTokenBal = await getTokenBalance(selectedToken.address);
  //       console.log(getTokenBal, "after swap");

  //       const resp = await API.TokenSwap({
  //         maker: userSigner.address,
  //         ethwOut: parseFloat(estimateETHWValue),
  //         tokenIn: parseFloat(estimateTokenValue),
  //         txHash: tx.hash,
  //         poolAddress: poolAddress,
  //         blockNumber: blockNumber,
  //         isBuyEthw: true,
  //         tokenAddress: selectedToken.address,
  //         ethwReserve: parseFloat(ethers.formatEther(ethwReserve.toString())),
  //         tokenReserve: parseFloat(ethers.formatEther(tokenReserve.toString())),
  //         tokenBalance: getTokenBal,
  //       });
  //       setBalance(getTokenBal);

  //       // if (!resp.data.status) return toast.info(resp.data.message);

  //       // toast.success("Swapped successful");
  //       toast.success(`${translate("swappedSuccess")}`);
  //       setLoading(false);
  //       setShowModal(true);
  //       setEstimateETHWValue("");
  //       setEstimateTokenValue("");
  //     } else {
  //       const userSigner = await signer();
  //       let provider = new BrowserProvider(window.ethereum);
  //       const tokenBalance = await provider.getBalance(userSigner);
  //       setLoading(true);
  //       if (
  //         parseFloat(ethers.formatEther(String(tokenBalance))) <=
  //         parseFloat(estimateETHWValue)
  //       ) {
  //         setLoading(false);
  //         setEstimateETHWValue("");
  //         setEstimateTokenValue("");
  //         // return toast.info("Insufficient balance");
  //         return toast.info(`${translate("insufficientBalance")}`);
  //       }
  //       const tx = await poolContract.swapTokens(
  //         true,
  //         ethers.parseEther(estimateETHWValue),
  //         {
  //           value: ethers.parseEther(estimateETHWValue),
  //         }
  //       );

  //       // toast.info("Swapping transaction initialized");
  //       toast.info(`${translate("swapInit")}`);
  //       await tx.wait();

  //       // const data = {
  //       //   from: poolAddress,
  //       //   to: userSigner.address,
  //       //   amountOfEthW: estimateETHWValue,
  //       //   amountOfToken: estimateTokenValue,
  //       //   transactionHash: tx.hash,
  //       //   poolAddress: poolAddress,
  //       //   tokenAddress: selectedToken.contractAddress,
  //       //   userAddress: userSigner.address,
  //       //   tradeType: true,
  //       //   tokenName: selectedToken.name,
  //       // };

  //       const ethwReserve = await poolContract.ethwReserve();
  //       const tokenReserve = await poolContract.tokenReserve();
  //       // const userAddress = await signer().getAddress();
  //       // console.log(userAddress,"useraddrsss")
  //       const blockNumber = await provider.getBlockNumber();

  //       // const resp = await API.SwapToken(data);
  //       // if (!resp.data.status) return toast.info(resp.data.message);
  //       // console.log("404", resp.data.message);
  //       const getTokenBal = await getTokenBalance(selectedToken.address);
  //       console.log(getTokenBal, "after swap");

  //       const resp = await API.TokenSwap({
  //         maker: userSigner.address,
  //         ethwIn: parseFloat(estimateETHWValue),
  //         tokenOut: parseFloat(estimateTokenValue),
  //         txHash: tx.hash,
  //         poolAddress: poolAddress,
  //         blockNumber: blockNumber,
  //         isBuyEthw: false,
  //         tokenAddress: selectedToken.address,
  //         ethwReserve: parseFloat(ethers.formatEther(ethwReserve.toString())),
  //         tokenReserve: parseFloat(ethers.formatEther(tokenReserve.toString())),
  //         tokenBalance: getTokenBal,
  //       });
  //       setBalance(getTokenBal);

  //       // if (!resp.data.status) return toast.info(resp.data.message);

  //       // toast.success("Swapped successful");
  //       toast.success(`${translate("swappedSuccess")}`);
  //       setLoading(false);
  //       setShowModal(true);
  //       setEstimateETHWValue("");
  //       setEstimateTokenValue("");
  //     }
  //   } catch (err) {
  //     if (err.action) {
  //       // toast.error("Transaction Cancelled");
  //       toast.error(`${translate("txCancelled")}`);
  //       // console.log("415", err.info.error.message);
  //     } else {
  //       // toast.info("Please enter valid details");
  //       toast.info(`${translate("enterValidDetails")}`);
  //       // console.log("418", err.message);
  //     }
  //     // console.log("err", err.message);
  //     setLoading(false);
  //   }
  // };

  const swapHandler = async () => {
    if (!sessionStorage.getItem("account")) {
      toast.error(translate("banner.connectmetamask"));
      return;
    }

    // helpers
    const num = (v) => Number((v ?? "").toString().trim() || 0);
    const isPos = (v) => Number.isFinite(v) && v > 0;

    try {
      setLoading(true);

      const contract = await contractInstance(swapContract, swapABI);
      const poolAddress = await contract.getPair(selectedToken.address);
      if (poolAddress === ethers.ZeroAddress) {
        toast.info(translate("banner.poolnotexist"));
        return;
      }

      const poolContract = await contractInstance(poolAddress, poolABI);
      const userSigner = await signer();
      const userAddress = await userSigner.getAddress();
      const provider = new BrowserProvider(window.ethereum);

      const tokenDecimals = selectedToken.decimals ?? 18;

      // user inputs (strings -> trimmed)
      const estTokStr = (estimateTokenValue || "").trim();
      const estEthStr = (estimateETHWValue || "").trim();

      const estTok = num(estTokStr);
      const estEth = num(estEthStr);

      // refresh reserves just for analytics later
      const refreshReserves = async () => {
        const ethwReserve = await poolContract.ethwReserve();
        const tokenReserve = await poolContract.tokenReserve();
        return {
          ethwReserveF: Number(ethers.formatEther(ethwReserve)),
          tokenReserveF: Number(
            ethers.formatUnits(tokenReserve, tokenDecimals)
          ),
        };
      };

      if (isSwapped) {
        // =========================
        // TOKEN -> ETHW  (user sells token for ETHW)
        // =========================
        // Require a positive token amount
        if (!isPos(estTok)) {
          setEstimateETHWValue("");
          setEstimateTokenValue("");
          toast.info(translate("banner.enteramount"));
          return;
        }

        const tokenContract = await contractInstance(
          selectedToken.address,
          ERC20ABI
        );

        // balance check
        const bal = await tokenContract.balanceOf(userAddress);
        const balF = Number(ethers.formatUnits(bal, tokenDecimals));
        if (balF + 1e-18 < estTok) {
          setEstimateETHWValue("");
          setEstimateTokenValue("");
          toast.info(translate("banner.insufficientbalance"));
          return;
        }

        const amountInTokens = ethers.parseUnits(estTokStr, tokenDecimals);

        // allowance check – only approve if needed
        const allowance = await tokenContract.allowance(
          userAddress,
          poolAddress
        );
        if (allowance < amountInTokens) {
          const approveTx = await tokenContract.approve(
            poolAddress,
            amountInTokens
          );
          toast.info(translate("banner.approvetransaction"));
          await approveTx.wait();
          toast.success(translate("banner.approvalsuccessful"));
        }

        // do the swap: token->ETHW uses legacy exact-input path
        toast.info(translate("banner.confirmswapmetaMask"));
        const tx = await poolContract.swapTokens(false, amountInTokens); // false = token->ETHW
        toast.info(translate("banner.swappinginitialized"));
        await tx.wait();

        const { ethwReserveF, tokenReserveF } = await refreshReserves();
        const blockNumber = await provider.getBlockNumber();
        const getTokenBal = await getTokenBalance(selectedToken.address);
        await API.TokenSwap({
          maker: userAddress,
          ethwOut: estEth || 0, // estimated ETH out (UI calc)
          tokenIn: estTok, // tokens sold
          txHash: tx.hash,
          poolAddress,
          blockNumber,
          isBuyEthw: true, // sold token -> bought ETHW
          tokenAddress: selectedToken.address,
          ethwReserve: ethwReserveF,
          tokenReserve: tokenReserveF,
          tokenBalance: getTokenBal,
        });

        setBalance(getTokenBal);
        await fetchETHWBalance();
        toast.success(translate("banner.swappedsuccessfully"));
        setShowModal(true);
        setEstimateETHWValue("");
        setEstimateTokenValue("");
      } else {
        // =========================
        // ETHW -> TOKEN  (user buys token with ETHW)
        // We prefer EXACT-OUTPUT for clean "exact 100" delivery if token amount is provided.
        // =========================

        const tokenOutProvided = isPos(estTok); // user typed token target
        if (tokenOutProvided) {
          // ---- EXACT OUTPUT PATH ----
          // 1) Quote exact ETH needed from view fn to avoid 99.9999 rounding
          const tokenOut = ethers.parseUnits(estTokStr, tokenDecimals);

          // sanity: pool has enough tokens
          const tokBal = await poolContract.tokenReserve();
          if (tokBal <= tokenOut) {
            toast.info(translate("banner.insufficientliquidity"));
            return;
          }

          // compute required ETH (fee only on ETH)
          const ethRequired = await poolContract.getEthInForTokenOut(tokenOut);
          const ethRequiredF = Number(ethers.formatEther(ethRequired));

          // 2) Wallet ETH balance check
          const userEthBal = await provider.getBalance(userAddress);
          const userEthF = Number(ethers.formatEther(userEthBal));
          if (userEthF + 1e-18 < ethRequiredF) {
            setEstimateETHWValue("");
            setEstimateTokenValue("");
            toast.info(translate("banner.insufficientETHW"));
            return;
          }

          // 3) Execute exact-output swap. Contract refunds any extra ETH if sent.
          toast.info(translate("banner.confirmswapmetaMask"));
          const tx = await poolContract.swapExactEthForTokens(tokenOut, {
            value: ethRequired,
          });
          toast.info(translate("banner.swappinginitialized"));
          await tx.wait();

          const { ethwReserveF, tokenReserveF } = await refreshReserves();
          const blockNumber = await provider.getBlockNumber();
          const getTokenBal = await getTokenBalance(selectedToken.address);
          await API.TokenSwap({
            maker: userAddress,
            ethwIn: ethRequiredF,
            tokenOut: estTok,
            txHash: tx.hash,
            poolAddress,
            blockNumber,
            isBuyEthw: false, // buying token with ETHW
            tokenAddress: selectedToken.address,
            ethwReserve: ethwReserveF,
            tokenReserve: tokenReserveF,
            tokenBalance: getTokenBal,
          });

          setBalance(getTokenBal);
          await fetchETHWBalance();
          toast.success(translate("banner.swappedsuccessfully"));
          setShowModal(true);
          // reflect authoritative ETH-in on UI
          setEstimateETHWValue(String(ethRequiredF));
          setEstimateTokenValue(estTokStr);
        } else {
          // ---- EXACT INPUT PATH (fallback) ----
          // If the user only typed ETH amount, keep legacy exact-input swap.
          if (!isPos(estEth)) {
            setEstimateETHWValue("");
            setEstimateTokenValue("");
            toast.info(translate("banner.EnterETHWamount"));
            return;
          }

          const userEthBal = await provider.getBalance(userAddress);
          const userEthF = Number(ethers.formatEther(userEthBal));
          if (userEthF + 1e-18 < estEth) {
            setEstimateETHWValue("");
            setEstimateTokenValue("");
            toast.info(translate("banner.InsufficientETHWbalance"));
            return;
          }

          const ethIn = ethers.parseEther(estEthStr);

          toast.info(translate("banner.confirmswapmetaMask"));
          const tx = await poolContract.swapTokens(true, ethIn, {
            value: ethIn,
          }); // true = ETHW->token
          toast.info(translate("banner.swappinginitialized"));
          await tx.wait();

          const { ethwReserveF, tokenReserveF } = await refreshReserves();
          const blockNumber = await provider.getBlockNumber();
          const getTokenBal = await getTokenBalance(selectedToken.address);
          await API.TokenSwap({
            maker: userAddress,
            ethwIn: estEth,
            tokenOut: estTok || 0,
            txHash: tx.hash,
            poolAddress,
            blockNumber,
            isBuyEthw: false, // buying token with ETHW
            tokenAddress: selectedToken.address,
            ethwReserve: ethwReserveF,
            tokenReserve: tokenReserveF,
            tokenBalance: getTokenBal,
          });
          setBalance(getTokenBal);
          await fetchETHWBalance();
          toast.success(translate("banner.swappedsuccessfully"));
          setShowModal(true);
          // keep user inputs
        }
      }
    } catch (err) {
      if (err?.action) {
        toast.error(translate("banner.transactioncancelled"));
      } else {
        toast.info(
          err?.reason || err?.message || translate("banner.entervaliddetails")
        );
      }
    } finally {
      setLoading(false);
    }
  };

  const closeModal = () => {
    setShowModal(false);
  };
  const { toggleLanguage, language } = useLanguage();

  const translate = (key) => {
    const keys = key.split(".");
    return (
      keys.reduce((obj, keyPart) => obj?.[keyPart], translation[language]) ||
      key
    );
  };

  return (
    <div className="banner-bg section-bg">
      <div className="flex-bannerimg">
        {logos.map((logo, index) => (
          <NavLink to={logo.link} key={index}>
            <div className={`logo-img logo-${index + 1}`}>
              <div className="logo-info">{logo.name}</div>
            </div>
          </NavLink>
        ))}
      </div>
      <div className="main-div">
        <div className="div-table">
          <h1>
            {translate("banner.heading")} <br />
            {translate("banner.subHeading")}
          </h1>
          <div className="table-swap">
            {selectedVersion === "v2" ? (
              <>
                {/* <div className="dropdown mb-2">
                  <button
                    className="btn dropdown-btn-pool select-ver-dropdown-swap"
                    type="button"
                    onClick={() => setIsDropdownOpen((prev) => !prev)}
                  >
                    {selectedVersion}
                    <i className="fa fa-angle-down ms-1"></i>
                  </button>
                  {isDropdownOpen && (
                    <ul
                      className="dropdown-menu show select-ver-dropdown"
                      style={{ display: "block", position: "absolute" }}
                    >
                      <li>
                        <button
                          className="dropdown-item text-light"
                          onClick={() => {
                            setIsDropdownOpen(false);
                            handleVersionChange("v2");
                          }}
                        >
                          v2
                        </button>
                      </li>
                      <li>
                        <button
                          className="dropdown-item text-light"
                          onClick={() => {
                            setIsDropdownOpen(false);
                            handleVersionChange("v3");
                          }}
                        >
                          v3
                        </button>
                      </li>
                    </ul>
                  )}
                </div>{" "} */}
                {!isSwapped ? (
                  <>
                    <div className="swap-value mb-1">
                      <div className="grey-color">
                        {translate("banner.actions.sell")}
                      </div>
                      <div className="enter-val grey-color">
                        <div className="grey-color">
                          <input
                            type="text"
                            value={estimateETHWValue}
                            onChange={handleETHWInput}
                            placeholder="0"
                            id="number-input"
                            className="text-white "
                            autoComplete="off"
                            // onKeyDown={(e) => {
                            //   if (
                            //     !/[0-9.]/.test(e.key) &&
                            //     e.key !== "Backspace" &&
                            //     e.key !== "Delete" &&
                            //     e.key !== "ArrowLeft" &&
                            //     e.key !== "ArrowRight" &&
                            //     e.key !== "Tab"
                            //   ) {
                            //     e.preventDefault();
                            //   }
                            // }}
                            // disabled
                          />
                        </div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "end",
                            flexDirection: "column",
                          }}
                        >
                          <button
                            type="button"
                            className="btn backdrop-btn-css"
                            // data-bs-toggle="modal"
                            // data-bs-target="#selectmodal1"
                          >
                            <div className="flex-class text-white ">
                              <img
                                src="https://res.cloudinary.com/dbtsrjssc/image/upload/v1733220306/B870CB730078368E_tedoei.webp"
                                alt=""
                                className="modal-img-btn"
                              />
                              ETHW
                              {/* <i className="fa fa-angle-down grey-clr"></i> */}
                            </div>
                          </button>
                          <div style={{ fontSize: "small", width: "7rem" }}>
                            {ethwBalance !== null ? (
                              <>{ethwBalance} ETHW </>
                            ) : (
                              <></>
                            )}

                            {error && <p style={{ color: "red" }}>{error}</p>}
                          </div>
                        </div>
                      </div>
                      <div className="loading-div"></div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      onClick={swapDivs}
                    >
                      <i
                        className="fa fa-arrow-down "
                        style={{
                          color: "#fff",
                          cursor: "pointer",
                          backgroundColor: " rgb(32, 32, 32)",
                          padding: "10px",
                          position: "absolute",
                          borderRadius: "10px",
                        }}
                      ></i>
                    </div>
                    <div className="swap-value mt-1">
                      <div className="grey-color">
                        {translate("banner.actions.buy")}
                      </div>
                      <div className="enter-val grey-color">
                        <div className="grey-color">
                          <input
                            type="text"
                            placeholder="0"
                            id="number-input"
                            value={estimateTokenValue}
                            className="text-white "
                            onChange={handleTokenInput}
                            autoComplete="off"
                          />
                        </div>
                        <div className="select-token-btn">
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexDirection: "column",
                            }}
                          >
                            <button
                              type="button"
                              className="btn btn-modal-backdrop"
                              data-bs-toggle="modal"
                              data-bs-target="#selecttoken2"
                            >
                              <div
                                className="flex-class text-white "
                                style={{ textWrap: "nowrap" }}
                              >
                                {selectedToken ? (
                                  <>
                                    <img
                                      src={selectedToken?.image}
                                      alt=""
                                      className="modal-img-btn"
                                    />
                                    {selectedToken.symbol?.toUpperCase()}
                                  </>
                                ) : (
                                  translate("banner.actions.selectToken")
                                )}
                                <i className="fa fa-angle-down"></i>
                              </div>
                            </button>{" "}
                            <div
                              style={{
                                fontSize: "small",
                                // width: "6rem",
                                whiteSpace: "nowrap",
                                // overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {selectedToken
                                ? `${
                                    balance !== null
                                      ? `${balance} ${selectedToken.symbol?.toUpperCase()}`
                                      : ""
                                  }`
                                : ""}
                            </div>
                          </div>
                          <div
                            className="modal "
                            id="selecttoken2"
                            tabIndex={-1}
                            aria-labelledby="exampleModalLabel"
                            aria-hidden="true"
                          >
                            <div className="modal-dialog modal-dialog-scrollable">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h1
                                    className="modal-title fs-5"
                                    id="exampleModalLabel"
                                  >
                                    {translate("banner.actions.selectToken")}
                                  </h1>
                                  <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                  ></button>
                                </div>
                                <div
                                  className="modal-body"
                                  ref={containerRef}
                                  onScroll={handleScroll}
                                  style={{
                                    maxHeight: "80vh",
                                    overflowY: "auto",
                                  }}
                                >
                                  <input
                                    type="text"
                                    name="userToken"
                                    placeholder={translate(
                                      "enterContractAddress"
                                    )}
                                    className="form-control search-input-box search-input-box-2 pt-2 pb-2 mb-2"
                                    // value={selectToken}
                                    onChange={selectHandler}
                                    autoComplete="off"
                                  />{" "}
                                  {tokenData?.length === 0 &&
                                    allTokensLoading && <Loading />}
                                  {tokenData?.length === 0 &&
                                    !allTokensLoading && (
                                      <div className="suggestion-item">
                                        {translate("noResultFound")}
                                      </div>
                                    )}
                                  {tokenData && tokenData.length > 0 && (
                                    <>
                                      {tokenData.map((suggestion, index) => (
                                        <div
                                          key={index}
                                          className="suggestion-item token-suggestions-data"
                                          data-bs-dismiss="modal"
                                          onClick={() =>
                                            selectTokenHandler(suggestion)
                                          }
                                        >
                                          <div className="suggestion-img">
                                            <img
                                              src={suggestion?.image}
                                              alt=""
                                            />
                                          </div>
                                          <div className="model-data-flex">
                                            <div className="suggestion-name">
                                              {suggestion?.name} (
                                              <strong>
                                                {suggestion?.symbol.toUpperCase()}
                                              </strong>
                                              )
                                            </div>
                                            <div className="suggestion-sym contract-add-model">
                                              {suggestion?.address}
                                            </div>
                                          </div>
                                        </div>
                                      ))}
                                      {allTokensLoading && <Loading />}{" "}
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>{" "}
                  </>
                ) : (
                  <>
                    {" "}
                    <div className="swap-value mb-1">
                      <div className="grey-color">
                        {translate("banner.actions.sell")}
                      </div>
                      <div className="enter-val grey-color">
                        <div className="grey-color">
                          <input
                            type="text"
                            placeholder="0"
                            id="number-input"
                            value={estimateTokenValue}
                            className="text-white "
                            onChange={handleTokenSwapInput}
                            autoComplete="off"
                          />
                        </div>
                        <div className="select-token-btn">
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexDirection: "column",
                            }}
                          >
                            <button
                              type="button"
                              className="btn btn-modal-backdrop"
                              data-bs-toggle="modal"
                              data-bs-target="#selecttoken3"
                            >
                              <div
                                className="flex-class text-white "
                                style={{ textWrap: "nowrap" }}
                              >
                                {selectedToken ? (
                                  <>
                                    <img
                                      src={selectedToken?.image}
                                      alt=""
                                      className="modal-img-btn"
                                    />
                                    {selectedToken?.symbol.toUpperCase()}
                                  </>
                                ) : (
                                  translate("banner.actions.selectToken")
                                )}
                                <i className="fa fa-angle-down "></i>
                              </div>
                            </button>
                            <div
                              style={{
                                fontSize: "small",
                                // width: "6rem",
                                whiteSpace: "nowrap",
                                // overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {" "}
                              {/* {ethwBalance !== null ? (
                            <>{ethwBalance} ETHW </>
                          ) : (
                            <></>
                          )} */}
                              {selectedToken
                                ? `${
                                    balance !== null
                                      ? `${balance} ${selectedToken?.symbol?.toUpperCase()}`
                                      : ""
                                  }`
                                : ""}
                            </div>
                          </div>
                          <div
                            className="modal "
                            id="selecttoken3"
                            tabIndex={-1}
                            aria-labelledby="exampleModalLabel"
                            aria-hidden="true"
                          >
                            <div className="modal-dialog modal-dialog-scrollable">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h1
                                    className="modal-title fs-5"
                                    id="exampleModalLabel"
                                  >
                                    {translate("banner.actions.selectToken")}
                                  </h1>
                                  <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                  ></button>
                                </div>
                                <div className="modal-body">
                                  <input
                                    type="text"
                                    name="userToken"
                                    placeholder={translate(
                                      "enterContractAddress"
                                    )}
                                    className="form-control search-input-box search-input-box-2 pt-2 pb-2 mb-2"
                                    // value={selectToken}
                                    onChange={selectHandler}
                                    autoComplete="off"
                                  />
                                  {tokenData ? (
                                    tokenData.map((suggestion, index) => (
                                      <div
                                        key={index}
                                        className="suggestion-item token-suggestions-data"
                                        onClick={() =>
                                          selectTokenHandler(suggestion)
                                        }
                                        data-bs-dismiss="modal"
                                      >
                                        <div className="suggestion-img">
                                          <img src={suggestion?.image} alt="" />
                                        </div>
                                        <div className="model-data-flex">
                                          <div className="suggestion-name">
                                            {suggestion?.name} (
                                            <strong>
                                              {suggestion?.symbol.toUpperCase()}
                                            </strong>
                                            )
                                          </div>
                                          <div className="suggestion-sym contract-add-model">
                                            {suggestion?.address}
                                          </div>
                                        </div>
                                      </div>
                                    ))
                                  ) : (
                                    <div className="suggestion-item">
                                      {translate("noResultFound")}
                                    </div>
                                  )}
                                </div>
                                {/* <div className="modal-footer get-started-btn ok-btn">
                              <button
                                type="button"
                                className="btn text-white "
                                data-bs-dismiss="modal"
                              >
                                Ok
                              </button>
                            </div> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>{" "}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      onClick={swapDivs}
                    >
                      <i
                        className="fa fa-arrow-down "
                        style={{
                          cursor: "pointer",
                          color: "#fff",
                          backgroundColor: " rgb(32, 32, 32)",
                          padding: "10px",
                          position: "absolute",
                          borderRadius: "10px",
                        }}
                      ></i>
                    </div>{" "}
                    <div className="swap-value mt-1">
                      <div className="grey-color">
                        {translate("banner.actions.buy")}
                      </div>
                      <div className="enter-val grey-color">
                        <div className="grey-color">
                          <input
                            type="text"
                            value={estimateETHWValue}
                            onChange={handleETHWSwapInput}
                            placeholder="0"
                            id="number-input"
                            className="text-white "
                            autoComplete="off"
                            // onKeyDown={(e) => {
                            //   if (
                            //     !/[0-9.]/.test(e.key) &&
                            //     e.key !== "Backspace" &&
                            //     e.key !== "Delete" &&
                            //     e.key !== "ArrowLeft" &&
                            //     e.key !== "ArrowRight" &&
                            //     e.key !== "Tab"
                            //   ) {
                            //     e.preventDefault();
                            //   }
                            // }}
                          />
                        </div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "end",
                            flexDirection: "column",
                          }}
                        >
                          <button
                            type="button"
                            className="btn btn-modal-backdrop"
                            // data-bs-toggle="modal"
                            // data-bs-target="#selecttoken4"
                          >
                            <div className="flex-class text-white ">
                              <img
                                src="https://res.cloudinary.com/dbtsrjssc/image/upload/v1733220306/B870CB730078368E_tedoei.webp"
                                alt=""
                                className="modal-img-btn"
                              />
                              ETHW
                              {/* <i className="fa fa-angle-down grey-clr"></i> */}
                            </div>
                          </button>
                          <div style={{ fontSize: "small", width: "7rem" }}>
                            {ethwBalance !== null ? (
                              <>{ethwBalance} ETHW </>
                            ) : (
                              <></>
                            )}

                            {error && <p style={{ color: "red" }}>{error}</p>}
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
                {showModal && (
                  // <div className="modal show d-block" tabIndex="-1" role="dialog">
                  <div
                    className="modal modal-backcss show d-block"
                    id="staticBackdrop"
                    data-bs-backdrop="static"
                    data-bs-keyboard="false"
                    tabindex="-1"
                    aria-labelledby="staticBackdropLabel"
                    aria-hidden="true"
                  >
                    <div
                      className="modal-dialog   modal-dialog-centered"
                      role="document"
                    >
                      <div className="modal-content text-center">
                        <div className="modal-header">
                          <h5 className="modal-title">
                            {/* Swap Successful */}
                            {translate("swapSuccessful")}
                          </h5>
                          <button
                            type="button"
                            className="btn-close"
                            aria-label="Close"
                            onClick={closeModal}
                          ></button>
                        </div>
                        <div className="modal-body">
                          <p style={{ marginBottom: "0" }}>
                            {/* Tokens swapped successfully! */}
                            {translate("tokensSwappedSuccess")}{" "}
                          </p>
                        </div>
                        <div className="modal-footer">
                          <button
                            style={{
                              backgroundColor: "#00a8e8",
                              color: "#fff",
                              fontWeight: "500",
                            }}
                            type="button"
                            className="btn"
                            onClick={closeModal}
                          >
                            {/* Close */} {translate("close")}{" "}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <div
                  className={`get-started-btn ${
                    !selectedToken ? "disabled" : ""
                  }`}
                  onClick={swapHandler}
                  // disabled={!selectedToken || loading}
                >
                  <button
                    className="text-white "
                    disabled={!selectedToken || loading}
                    style={{
                      cursor: selectedToken ? "pointer" : "no-drop",
                      backgroundColor: !selectedToken ? "grey" : "",
                    }}
                  >
                    {loading ? (
                      <Loading />
                    ) : (
                      translate("banner.actions.getStarted")
                    )}
                  </button>{" "}
                </div>
                {!selectedToken && (
                  <p style={{ textAlign: "center" }}>
                    {translate("banner.selectTokenWarning")}
                    {/* Please select a token to get started */}
                  </p>
                )}
              </>
            ) : (
              <V3Swap
                selectedVersion={selectedVersion}
                handleVersionChange={handleVersionChange}
              />
            )}
          </div>{" "}
        </div>
      </div>
    </div>
  );
};

export default Banner;
